import { FilterOptionKeys } from '@griply/types';
import { TFunction } from 'i18next';
import { TimerClockFast16 } from 'shared/assets/icons';
import { FilterNumberRangeOption, FilterOptionType } from 'shared/types/filter';

export type Options = {
  t: TFunction;
};

export const createDurationFilter = ({
  t,
}: Options): FilterNumberRangeOption => ({
  id: FilterOptionKeys.Duration,
  label: t('context-menus.filtering.task.filters.duration.title'),
  minLabel: t('context-menus.filtering.task.filters.duration.more.label'),
  maxLabel: t('context-menus.filtering.task.filters.duration.less.label'),
  placeholder: t('general.labels.select'),
  icon: TimerClockFast16,
  type: FilterOptionType.NumberRange,
  canReset: true,
});
